import { Box, Image } from '@chakra-ui/react';
import { FC } from 'react';
import { useDevice } from '../../../../hooks/useDevice';
import { useDefaultStyles } from '../../../../hooks/useDefaultStyles';

export const ModeratorAvatar: FC = () => {
  const device = useDevice();
  const { colors } = useDefaultStyles();

  return (
    <Box
      boxSize={device === 'web' ? '48px' : '40px'}
      backgroundColor={colors.secondary.keep}
      borderRadius="full"
      overflow="hidden"
      padding="2px"
      marginRight={2}
    >
      <Image
        src="/images/logo-aristo-forum.svg"
        alt="Equipe Aristo"
        boxSize="100%"
        objectFit="contain"
      />
    </Box>
  );
};
